var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isMibile)?_c('Header',{class:{ 'to_top': _vm.isShow }}):_vm._e(),(_vm.isMibile && !_vm.isPlatformWebView)?_c('MobileHeader'):_vm._e(),_c('router-view'),(!_vm.isMibile)?_c('Footer'):_vm._e(),(_vm.isMibile && !_vm.isPlatformWebView)?_c('MobileFooter'):_vm._e(),(!_vm.isMibile)?_c('HomeSide'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }